import { Store } from 'pullstate'
import { LeadFilter, OptionWithSelect } from '../features/autocomplete/types';

export type Sprint = {
    id: string,
    name: string,
    playbookName: string,
    playbookId: string,
    startDate: string,
    endDate: string,
    sprintTypeId: string,
    sprintTypeName: string,
    sprintStatusId: string,
    sprintStatusName: string,
    customerId: string,
    customerName: string,
    locationId: string
    idealCustomerProfiles: IdealCustomerProfileListItem[]
}

export type IdealCustomerProfileListItem = {
    id: string,
    name: string,
    sprintId: string,
    candenceId: string,
    cadenceName: string,
    startDate: string
}

const SprintStore = new Store({
    sprints: [] as Sprint[],
    leadFilters: {
        searchTerm: '',
        options: [] as OptionWithSelect[]
    } as LeadFilter
});

export { SprintStore }
export default SprintStore